import React from "react";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

export function AccountAccessHelp({ redirectTo, text }) {
  return (
    <>
      <Divider style={{ margin: "12px 0" }} />
      <Grid container justify="center">
        <Grid item>
          <Button to={redirectTo} component={Link}>
            {text}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
